import { PostCreateJEAccrual } from '../../../domain/usecases/';

import { BaseHttpService } from 'main/factories/http';

export class RemoteCreateJEAccruals extends BaseHttpService<PostCreateJEAccrual.Model> implements PostCreateJEAccrual {
  async createJEAccruals(body: PostCreateJEAccrual.Params): Promise<PostCreateJEAccrual.Model> {
    return await this.request('post', body);
  }
}
